import { baseUrl } from "./utils";

export const sendContact = async (body, setLoading) => {
  try {
    setLoading(true);
    const responce = await fetch(baseUrl + "contact", {
      method: "POST",
      body: body,
    });
    const res = await responce.json();
    setLoading(false);
    console.log(res);
    return res;
  } catch (error) {
    setLoading(false);
    console.log(error);
  }
};
export const get_machine = async (body, setLoading) => {
  try {
    setLoading(true);
    const responce = await fetch(baseUrl + "machine-list", {
      method: "POST",
      body: body,
    });
    const res = await responce.json();
    setLoading(false);
    console.log(res);
    return res;
  } catch (error) {
    setLoading(false);
    console.log(error);
  }
};
export const get_generate = async (body, setLoading) => {
  try {
    setLoading(true);
    const responce = await fetch(baseUrl + "generate", {
      method: "POST",
      body: body,
    });
    const res = await responce.json();
    setLoading(false);
    console.log(res);
    return res;
  } catch (error) {
    setLoading(false);
    console.log(error);
  }
};
